import React, { useState, useEffect } from 'react'
import { navigate } from 'gatsby'
import * as styles from './search.module.css'
import closeIcon from '../../images/icons/close-svgrepo-com.svg'
import translate from '../../helpers/Translate'
import { GatsbyImage } from 'gatsby-plugin-image';
import { useQueryParam, StringParam } from 'use-query-params'

export const SearchBlock = ({ allPosts, setSearch }) => {

    const [ results, setResults ] = useState([])

    const [ showResults, setShowResults ] = useState( false )

    const [ query, setQuery ] = useQueryParam( 's', StringParam )

    const [ searchWord, setSearchWord ] = useState('')

    const [ loading, setLoading ] = useState( false )

    const searchHandler = async ( e ) => {
        
        setSearchWord( e.target.value )

    }

    useEffect(() => {

        searchWord !== '' ? setShowResults( true ) : setShowResults( false )

        setLoading( true )

        setTimeout(() => {

            searchWord !== '' && callSearch()

        }, 1000 )

    }, [ searchWord ])

    const [ width, setWidth ] = useState( 0 )
    const [ opacity, setOpacity ] = useState( 0 )

    useEffect(() => {
        setTimeout(() => {
            setWidth( 450 )
           
        }, 100 )
        setTimeout(() => {
            setOpacity( 1 )
        }, 150 )
    }, [  ])

    const callSearch = async () => {

      let res = []

      allPosts.forEach( post => {

        let sw = searchWord.toLowerCase()

        sw = sw.replaceAll( '-', ' ' )

        let title = post.node.title.toLowerCase().replaceAll( '-', ' ' )

        if( title.includes( sw ) ) {

          res.push( post.node )
          
        }

      })

      setResults( res )

      setLoading(false)

     
      if ( '/search-results/' ===  window.location.pathname ) {
        setQuery( searchWord )
      }

    }

    const hadleSearch = () => {

      setShowResults(false)

      navigate(`/search-results/?s=${searchWord}`)

    }

    return(
        <>
        <div className={styles.searchBlock} style={{ width : width + 'px', opacity : opacity }}>
            <div className={styles.searchBlock__input}>
                <input placeholder={translate('Search on site...')} onChange={( e ) => searchHandler( e )} value={searchWord}/>
                <img src={closeIcon} onClick={() => setSearch( false )}/>
            </div>
            
            {showResults &&  
            <div className={styles.searchBlock__results}>
                {loading &&
                <span style={{ paddingLeft : '15px', marginBottom : '15px' }}>{translate('Loading results...')}</span>
                }
                {!loading &&
                <ul>
                    {results.map((item, id) => 
                        id < 3 &&
                        <li className={styles.searchBlock__item}>
                            <div className={styles.searchBlock__item__img}>
                                <GatsbyImage image={item?.featuredImage?.node?.gatsbyImage}/>
                                {/* <img src={item.node?.featuredImage?.gatsbyImage} /> */}
                            </div>
                            
                            <a href={item.uri} className={styles.searchBlock__item__link}>{item.title}</a>
                        </li>
                    )}
                    {results.length > 0 ? 
                    <li>
                        <span className={styles.allResults} style={{ cursor : 'pointer' }} onClick={() => hadleSearch()}>{translate('Show all')} {results.length} {translate('results')}...</span>
                    </li>
                    :
                    <span style={{ paddingLeft : '15px', marginBottom : '15px' }}>{translate('Nothing found for your request...')}</span>}
                </ul>
                }
            </div>}
            
        </div>
        </>
    )
}